// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z3vj","colBig":"styles_colBig__6N4x5","colSmall":"styles_colSmall__3KiF7"};